// extracted by mini-css-extract-plugin
export default {"actionsMenu":"ActionMenu_actionsMenu__XxQU9","changeButton":"ActionMenu_changeButton__rziLT","deleteButton":"ActionMenu_deleteButton__LBn8C"};